import { INewAnswer } from '../../types/newAnswer';
import { ICreateAnswerRequest } from '../../repositories/newbuilding-reviews/v1/create-answer';
import { EReviewerStatus } from '../../repositories/newbuilding-reviews/entities/create_answer/CreateAnswerRequestSchema';

export const prepareNewAnswer = (reviewId: string, newAnswer: INewAnswer): ICreateAnswerRequest => {
  return {
    reviewId,
    userName: newAnswer.data.name,
    reviewerStatus: newAnswer.data.userStatus as unknown as EReviewerStatus,
    text: newAnswer.data.answer,
    isAnonymous: newAnswer.data.isAnonymous,
  };
};
